// paymentUtils.js

/**
 * Determines if the user is in an Indian timezone
 * Uses multiple detection methods for better reliability
 * 
 * @returns {Boolean} True if user is in India, false otherwise
 */
export const isIndianUser = () => {
  try {
    // Method 1: Check timezone directly
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    
    // Method 2: Check timezone offset (IST is UTC+5:30 = -330 minutes)
    const timezoneOffset = new Date().getTimezoneOffset();
    
    // Method 3: Check browser language
    const userLanguage = navigator.language || navigator.userLanguage || '';
    
    // Check if user is in an Indian timezone or using Indian language
    const hasIndianTimezone = 
      userTimezone.includes('Asia/Kolkata') || 
      userTimezone.includes('Asia/Calcutta') ||
      userTimezone.includes('India');
      
    const hasIndianOffset = timezoneOffset === -330;
    const hasIndianLanguage = userLanguage.includes('in') || userLanguage.includes('hi-');
    
    // If any of these suggest the user is in India
    return hasIndianTimezone || hasIndianOffset || hasIndianLanguage;
  } catch (error) {
    // Fall back to false on error
    return false;
  }
};